;(function () {
  'use strict'

  angular
    .module('contrast.compliance-policy')
    .factory('compliancePolicyService', compliancePolicyServiceFactory)

  function compliancePolicyServiceFactory(
    $translate,
    $filter,
    ServiceUtils,
    compliancePolicyApiConfig,
    csTemplates,
    confirmModal,
    FILTER_GROUPS
  ) {
    'ngInject'

    var _deletePolicyTemplateUrl =
      'components-org/compliance-policy/delete.html'

    var service = {
      getPolicy: getPolicy,
      getPolicies: getPolicies,
      createPolicy: createPolicy,
      updatePolicy: updatePolicy,
      togglePolicyStatus: togglePolicyStatus,
      confirmAndDelete: confirmAndDelete,
      createRequest: createRequest,
      transformToPolicyView: transformToPolicyView
    }

    return service

    function getPolicy(policyId) {
      return compliancePolicyApiConfig
        .getPolicy(policyId)
        .then(ServiceUtils.handleResolve('data.policy'))
        .catch(ServiceUtils.handleError)
    }

    function getPolicies(limit, offset, searchKey, sortRow) {
      return compliancePolicyApiConfig
        .getPolicies(limit, offset, searchKey, sortRow)
        .then(function (response) {
          response.data.policies.map(function (policy) {
            policy.limitCriteria = 3
            policy.limitApplication = 3
            policy.criterias = _transformCriterias(policy)
            policy.apps = _transformApps(policy)

            return policy
          })

          return response.data
        })
        .catch(ServiceUtils.handleError)
    }

    function _transformCriterias(policy) {
      var criterias = []
      if (angular.isArray(policy.rule_severities)) {
        var severities = $filter('orderBy')(policy.rule_severities)
        var i = 0
        for (; i < severities.length; i++) {
          criterias.push($filter('camelCase')(severities[i]))
        }
      }

      if (angular.isArray(policy.standards)) {
        criterias.push.apply(
          criterias,
          _.map(
            $filter('orderBy')(policy.standards, 'short_name'),
            'short_name'
          )
        )
      }

      if (angular.isArray(policy.rules)) {
        criterias.push.apply(
          criterias,
          _.map($filter('orderBy')(policy.rules, 'title'), 'title')
        )
      }
      return criterias
    }

    function _transformApps(policy) {
      var apps = []
      if (angular.isArray(policy.application_importance)) {
        var importance = $filter('orderBy')(policy.application_importance)
        var impArray = importance.map(function (imp) {
          return {
            label: imp,
            type: 'Importance'
          }
        })
        apps.push.apply(apps, impArray)
      }

      if (angular.isArray(policy.applications)) {
        var appArray = $filter('orderBy')(policy.applications, 'name')
        appArray.map(function (a) {
          a.type = 'Application'
          return a
        })
        apps.push.apply(apps, appArray)
      }

      return apps
    }

    function createPolicy(data) {
      return compliancePolicyApiConfig
        .createPolicy(data)
        .then(
          ServiceUtils.handleResolve('', { log: ServiceUtils.LOGGER.SUCCESS })
        )
        .catch(ServiceUtils.handleError)
    }

    function updatePolicy(policyId, data) {
      return compliancePolicyApiConfig
        .updatePolicy(policyId, data)
        .then(
          ServiceUtils.handleResolve('', { log: ServiceUtils.LOGGER.SUCCESS })
        )
        .catch(ServiceUtils.handleError)
    }

    function togglePolicyStatus(policyId) {
      return compliancePolicyApiConfig
        .togglePolicyStatus(policyId)
        .catch(ServiceUtils.handleError)
    }

    function confirmAndDelete(policy) {
      return csTemplates
        .loadAndInterpolate(_deletePolicyTemplateUrl, {
          policyName: policy.name
        })
        .then(function (interpolatedStr) {
          return _launchDeleteDialog(interpolatedStr, policy)
        })
    }

    function _launchDeleteDialog(msg, policy) {
      var transl = {
        title_compliancePolicy_deletePolicy: $translate.instant(
          'title_compliancePolicy_deletePolicy'
        ),
        action_delete: $translate.instant('action_delete'),
        action_cancel: $translate.instant('action_cancel')
      }

      return confirmModal
        .open({
          title: transl.title_compliancePolicy_deletePolicy,
          message: msg,
          dialogOptions: {
            size: 'md-sm',
            yes: transl.action_delete,
            no: transl.action_cancel
          }
        })
        .then(function (confirmed) {
          if (confirmed) {
            return _deletePolicy(policy)
          }
        })
    }

    function _deletePolicy(policy) {
      return compliancePolicyApiConfig
        .removePolicy(policy.policy_id)
        .then(
          ServiceUtils.handleResolve('', { log: ServiceUtils.LOGGER.SUCCESS })
        )
        .catch(ServiceUtils.handleError)
    }

    function createRequest(policy) {
      var data = {
        name: policy.name,
        all_applications: policy.all_applications,
        application_importance: [],
        applications: [],

        all_rules: policy.all_rules,
        rule_severities: [],
        rules: [],
        standards: []
      }

      if (!data.all_applications) {
        _buildApplicationRequestSection(data, policy)
      }

      if (!data.all_rules) {
        _buildRulesRequestSection(data, policy)
      }

      return data
    }

    function _buildApplicationRequestSection(data, policy) {
      var i, appItem
      for (i = 0; i < policy.applications.length; i++) {
        appItem = policy.applications[i]
        if (appItem.group === FILTER_GROUPS.IMPORTANCE) {
          data.application_importance.push(appItem.value)
        } else {
          data.applications.push(appItem.value)
        }
      }
    }

    function _buildRulesRequestSection(data, policy) {
      var j, ruleItem
      for (j = 0; j < policy.rules.length; j++) {
        ruleItem = policy.rules[j]
        if (ruleItem.group === FILTER_GROUPS.SEVERITY) {
          data.rule_severities.push(ruleItem.value)
        } else if (ruleItem.group === FILTER_GROUPS.SECURITY_STANDARDS) {
          data.standards.push(ruleItem.value)
        } else {
          data.rules.push(ruleItem.value)
        }
      }
    }

    function transformToPolicyView(policy, apps, rules) {
      var form = {
        name: policy.name,
        readonly: policy.readonly,
        all_applications: policy.all_applications,
        all_rules: policy.all_rules,
        applications: [],
        rules: []
      }

      if (!form.all_applications) {
        _transformApplicationsToPolicyView(policy, apps, form)
      }

      if (!form.all_rules) {
        _transformRulesToPolicyView(policy, rules, form)
      }

      return form
    }

    function _transformApplicationsToPolicyView(policy, apps, form) {
      var i, value, objectItem
      for (i = 0; i < policy.applications.length; i++) {
        value = policy.applications[i]
        objectItem = _.find(apps, function (item) {
          return item.value === value.app_id
        })
        if (objectItem) {
          form.applications.push(objectItem)
        }
      }

      for (i = 0; i < policy.application_importance.length; i++) {
        value = policy.application_importance[i]
        objectItem = _.find(apps, function (item) {
          return item.value === value
        })
        if (objectItem) {
          form.applications.push(objectItem)
        }
      }
    }

    function _transformRulesToPolicyView(policy, rules, form) {
      var i, value, objectItem

      for (i = 0; i < policy.rules.length; i++) {
        value = policy.rules[i]
        objectItem = _.find(rules, function (item) {
          return item.value === value.name
        })
        if (objectItem) {
          form.rules.push(objectItem)
        }
      }
      for (i = 0; i < policy.rule_severities.length; i++) {
        value = policy.rule_severities[i]
        objectItem = _.find(rules, function (item) {
          return item.value === value
        })
        if (objectItem) {
          form.rules.push(objectItem)
        }
      }
      for (i = 0; i < policy.standards.length; i++) {
        value = policy.standards[i]
        objectItem = _.find(rules, function (item) {
          return item.value === value.name
        })
        if (objectItem) {
          form.rules.push(objectItem)
        }
      }
    }
  }
})()
